
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-7",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","class":"w-7","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.236 6.136a2.16 2.16 0 012.997-.749 2.144 2.144 0 01.726 2.908l-5.94 10.182a4.203 4.203 0 01-3.667 2.083.42.42 0 01-.383-.256 4.302 4.302 0 01.243-3.843l6.024-10.325z","fill":"#8B58FB"}}),_c('path',{attrs:{"d":"M2.6 12.998c0-1.145.928-2.074 2.074-2.074H9.88c1.598 0 2.596 1.732 1.794 3.114a2.074 2.074 0 01-1.794 1.033H4.674A2.073 2.073 0 012.6 12.998zm0 5.582c0-1.057.857-1.914 1.914-1.914H6.87c1.494 0 2.412 1.636 1.633 2.912a1.912 1.912 0 01-1.633.916H4.514A1.914 1.914 0 012.6 18.58z","fill":"#B99EF4"}}),_c('path',{attrs:{"d":"M2.6 6.937c0-.97.786-1.755 1.755-1.755h9.107c1.39 0 2.227 1.538 1.475 2.705a1.755 1.755 0 01-1.475.804H4.355A1.754 1.754 0 012.6 6.937z","fill":"#8B58FB"}})])
          )
        }
      }
    